<template>
  <div :class="[$style.ctn, { [$style.open]: isOpen }]">
    <button type="button" @click.stop="switchOpen">
      <span>{{ current }}</span>
      <SvgIcon width="22" height="22" src="icon-sprite.svg#arrow" />
    </button>
    <ul>
      <li v-for="(v, i) in values" v-show="i !== selected" :key="i">
        <button type="button" @click.stop="select(i)">
          <span>{{ v }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import SvgIcon from './SvgIcon.vue';

export default defineComponent({
  components: {
    SvgIcon,
  },
  props: {
    values: { type: Array, required: true },
    selected: { type: Number, default: null },
  },
  data() {
    return { isOpen: false };
  },
  computed: {
    current() {
      return this.selected !== null ? this.values[this.selected] : '—';
    },
  },
  mounted() {
    window.addEventListener('click', this.close);
  },
  beforeUnmount() {
    window.removeEventListener('click', this.close);
  },
  methods: {
    close() {
      this.isOpen = false;
    },
    select(i) {
      this.close();
      this.$emit('select', i);
    },
    switchOpen() {
      this.isOpen = !this.isOpen;
    },
  },
});
</script>

<style lang="scss" module>
.ctn {
  position: relative;
  button {
    width: 100%;
  }
  & > button {
    display: flex;
    justify-content: space-between;
    border: 1px solid #c0d1df;
    border-top-right-radius: 1px;
    border-top-left-radius: 1px;
    --icon-color: #c0d1df;
    &:hover {
      --icon-color: #42505d;
    }
  }
  svg {
    display: block;
    padding-right: 4px;
  }
  &.open {
    svg {
      transform: scaleY(-1);
    }
  }
  span {
    text-align: start;
    display: block;
    flex: 1 1 auto;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    letter-spacing: 0.02em;
    color: #59606e;
    min-width: 60px;
    padding: 4px 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  ul {
    position: absolute;
    width: 100%;
    list-style: none;
    display: none;
    background: white;
    border: 1px solid #c0d1df;
    border-top: none;
  }
  li {
    span {
      &:not(:hover) {
        font-weight: normal;
        color: rgba(89, 96, 110, 0.66);
      }
    }
  }
  &.open ul {
    display: block;
  }
}
</style>
